import { defineCatalogue } from '../../i18n';

export const registerCatalogue = defineCatalogue(
  {
    'create.open': 'Criar uma organização',
    'empty.title': 'Nenhuma organização ainda',
    'empty.body':
      'As pessoas criam uma organização ao se cadastrarem, ou você pode criar uma aqui.',
    'empty.action': 'Criar uma organização',
    'openRequest.some': 'Pedido em aberto',
    'openRequest.none': 'nenhum',
    'section.title': 'Registro',
    'section.count.other': '{n} de {total} organizações',
    'section.count.one': '{n} de {total} organização',
    rowLink: 'Ver detalhes',
    'filter.label': 'Filtrar organizações',
    'search.label': 'Buscar organização',
    'search.placeholder': 'Buscar organização',
    'view.groupLabel': 'Segmento',
    'view.active': 'Ativas',
    'view.funded': 'Com fundos',
    'view.waiting': 'Aguardando',
    'view.inert': 'Inertes',
    'view.all': 'Todas',
    withCount: '{label} · {count}',
    'openRequestFilter.label': 'Com pedido aberto',
    'noMatch.title': 'Nenhuma organização encontrada',
    'noMatch.body': 'Nenhuma organização com “{query}” no nome.',
    'noMatch.searchAll': 'Buscar em todas',
  },
  {
    'create.open': 'Create an organisation',
    'empty.title': 'No organisations yet',
    'empty.body': 'People create an organisation when they sign up, or you can create one here.',
    'empty.action': 'Create an organisation',
    'openRequest.some': 'Open request',
    'openRequest.none': 'none',
    'section.title': 'Register',
    'section.count.other': '{n} of {total} organisations',
    'section.count.one': '{n} of {total} organisation',
    rowLink: 'View details',
    'filter.label': 'Filter organisations',
    'search.label': 'Search organisation',
    'search.placeholder': 'Search organisation',
    'view.groupLabel': 'Segment',
    'view.active': 'Active',
    'view.funded': 'Funded',
    'view.waiting': 'Waiting',
    'view.inert': 'Inert',
    'view.all': 'All',
    withCount: '{label} · {count}',
    'openRequestFilter.label': 'Has an open request',
    'noMatch.title': 'No organisation found',
    'noMatch.body': 'No organisation has “{query}” in its name.',
    'noMatch.searchAll': 'Search across all',
  },
);

export const t = registerCatalogue.t;
